const SvgAdd2 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24">
    <path fill="#373737" fillRule="evenodd" d="M21 11.5H3v1h18z" clipRule="evenodd" />
    <path fill="#373737" fillRule="evenodd" d="M12.5 21V3h-1v18z" clipRule="evenodd" />
  </svg>;
export default SvgAdd2;